/*
 * Copyright 2014-2019 JetBrains s.r.o and contributors. Use of this source code is governed by the Apache 2.0 license.
 */

package io.ktor.client.features.logging

public actual val Logger.Companion.DEFAULT: Logger get() = SIMPLE
